import React, { useEffect, useState } from 'react';
import { AdminCrudShell, StatusBadge } from '@/components/admin/AdminCrudShell';
import { fetchSports } from '@/lib/api';

const STATUS_OPTIONS = [
  { value: 'active', label: 'Activo' },
  { value: 'inactive', label: 'Inactivo' },
  { value: 'hidden', label: 'Oculto' },
];

export default function AdminClubs() {
  const [sports, setSports] = useState([]);
  useEffect(() => {
    fetchSports().then(setSports).catch(() => setSports([]));
  }, []);
  const sportsOptions = sports.map((s) => ({ value: s.id, label: s.name }));
  const sportNameById = (id) => sports.find((s) => s.id === id)?.name || id || '—';

  return (
    <AdminCrudShell
      title="Clubes"
      subtitle="Gestión completa de clubes: deporte, localización, branding y estado."
      entity="clubs"
      testIdPrefix="admin-clubs"
      searchPlaceholder="Buscar club…"
      initialForm={{
        name: '', slug: '', sport_id: '',
        country: 'España', autonomous_community_or_region: '', province: '', city: '',
        description: '', logo_url: '', cover_image_url: '', founded_year: '', status: 'active',
      }}
      columns={[
        { key: 'name', label: 'Club', render: (r) => (
          <div>
            <div className="font-medium text-[var(--ns-text)]">{r.name}</div>
            <div className="text-xs text-[var(--ns-text-subtle)] font-mono">{r.slug}</div>
          </div>
        ) },
        { key: 'sport_id', label: 'Deporte', render: (r) => sportNameById(r.sport_id) },
        { key: 'city', label: 'Ubicación', render: (r) => [r.city, r.province, r.country].filter(Boolean).join(' · ') },
        { key: 'status', label: 'Estado', render: (r) => <StatusBadge status={r.status} /> },
      ]}
      formFields={[
        { name: 'name', label: 'Nombre del club', required: true, placeholder: 'CD Ejemplo' },
        { name: 'slug', label: 'Slug', placeholder: 'Auto-generado si vacío' },
        { name: 'sport_id', label: 'Deporte', type: 'select', required: true, options: sportsOptions },
        { name: 'country', label: 'País', required: true, placeholder: 'España' },
        { name: 'autonomous_community_or_region', label: 'Comunidad / Región', placeholder: 'Andalucía' },
        { name: 'province', label: 'Provincia', placeholder: 'Cádiz' },
        { name: 'city', label: 'Ciudad / Localidad', placeholder: 'San Fernando' },
        { name: 'description', label: 'Descripción', type: 'textarea', placeholder: 'Breve descripción del club…' },
        { name: 'logo_url', label: 'Logo del club', type: 'image', uploadKind: 'logo', aspectClass: 'aspect-square', hint: 'JPG o PNG. Se ajustará a un cuadrado (máx. 400×400) y se optimizará.' },
        { name: 'cover_image_url', label: 'Imagen de portada', type: 'image', uploadKind: 'cover', aspectClass: 'aspect-video', hint: 'JPG o PNG. Se ajustará a un panorámico 16:9 (máx. 1600×900) y se optimizará.' },
        { name: 'founded_year', label: 'Año de fundación', type: 'number', placeholder: '1948' },
        { name: 'status', label: 'Estado', type: 'select', required: true, options: STATUS_OPTIONS },
      ]}
    />
  );
}
